'use client'
import Image from 'next/image'
import { BussniessToolBotIntegration as Icon_BussniessToolBotIntegration } from "@/components/customer/icons/BussniessToolBotIntegration";
import { BussniessToolBotReplay as Icon_BussniessToolBotReplay } from "@/components/customer/icons/BussniessToolBotReplay";
import { BussniessToolCampaign as Icon_BussniessToolCampaign } from "@/components/customer/icons/BussniessToolCampaign";
import { BussniessToolDashboard as Icon_BussniessToolDashboard } from "@/components/customer/icons/BussniessToolDashboard";
import { BussniessToolGroup as Icon_BussniessToolGroup } from "@/components/customer/icons/BussniessToolGroup";
import { BussniessToolInviteMessage as Icon_BussniessToolInviteMessage } from "@/components/customer/icons/BussniessToolInviteMessage";
import { BussniessToolQrgenrate as Icon_BussniessToolQrgenrate } from "@/components/customer/icons/BussniessToolQrgenrate";
import { BussniessToolTemplate as Icon_BussniessToolTemplate } from "@/components/customer/icons/BussniessToolTemplate";
import { BussniessToolwhtasappInte as Icon_BussniessToolwhtasappInte } from "@/components/customer/icons/BussniessToolwhtasappInte";
import { TrustTick as Icon_TrustTick } from "@/components/customer/icons/TrustTick";
import { WhatsEaseBot as Icon_WhatsEaseBot } from "@/components/customer/icons/WhatseaseBot";
import { WhatseaseWhatsapp as Icon_WhatseaseWhatsapp } from "@/components/customer/icons/WhatseaseWhatsapp";
import { WhtasEaseKite as Icon_WhtasEaseKite } from "@/components/customer/icons/WhtasEaseKite";
const SvgIcons = { BussniessToolBotIntegration: Icon_BussniessToolBotIntegration, BussniessToolBotReplay: Icon_BussniessToolBotReplay, BussniessToolCampaign: Icon_BussniessToolCampaign, BussniessToolDashboard: Icon_BussniessToolDashboard, BussniessToolGroup: Icon_BussniessToolGroup, BussniessToolInviteMessage: Icon_BussniessToolInviteMessage, BussniessToolQrgenrate: Icon_BussniessToolQrgenrate, BussniessToolTemplate: Icon_BussniessToolTemplate, BussniessToolwhtasappInte: Icon_BussniessToolwhtasappInte, TrustTick: Icon_TrustTick, WhatsEaseBot: Icon_WhatsEaseBot, WhatseaseWhatsapp: Icon_WhatseaseWhatsapp, WhtasEaseKite: Icon_WhtasEaseKite };
import Link from 'next/link'
import TrustedPartners from "./TrustedPartners";
import GlobalPartnersCount from '@/components/GlobalPartnersCount';
import { WHATSEASE_STATS, WHATSEASE_UPDATED_AT } from '@/lib/whatseaseStats';
import UpdatedAt from '@/components/UpdatedAt';
import StatNumber from '@/components/StatNumber';
import StepsLayout from './WhtaseaseStepCom';
import { useAOS } from '@/hooks/useAOS';
import FaqSection from './FaqSection';

import TurnWhatsapp from './TurnWhatsapp';

import { getImageUrl } from '@/lib/imageUrl';

const WhatseaseView = () => {


  const faqs = [
    {
      question: "What is Vilva Chat?",
      answer: `
      Vilva Chat is the official business WhatsApp API + chatbot solution from Vilva Business that helps companies automate customer conversations, send campaigns, and engage users 24/7 — without losing a single message.
      <br/><br/>
      It’s built to help you convert more leads and delight customers at scale.
    `
    },
    {
      question: "How does Vilva Chat help my business grow?",
      answer: `
      Vilva Chat accelerates growth by enabling:
      <ul>
        <li>Automated customer support around the clock</li>
        <li>WhatsApp marketing campaigns to thousands of contacts</li>
        <li>Instant lead capture and follow-ups</li>
        <li>Rich chat automation to send messages, images, buttons, and more</li>
      </ul>
      This means you can engage audiences faster, answer questions automatically, and boost conversions without manual work.
    `
    },
    {
      question: "Can Vilva Chat send campaigns & promotions?",
      answer: `
      Yes! With Vilva Chat, you can create and send targeted WhatsApp campaigns to engage your customers with offers, updates, and promotions — directly through the official WhatsApp Business API.
    `
    },
    {
      question: "Is Vilva Chat a “WhatsApp chatbot”?",
      answer: `
      Absolutely. Vilva Chat includes a powerful WhatsApp chatbot that can answer customer questions automatically and intelligently, so you never miss a lead or query, even when your team is offline.
    `
    },
    {
      question: "Can Vilva Chat integrate with my current systems?",
      answer: `
      Yes. Vilva Chat can work alongside your CRM, website forms, and other systems, helping you funnel conversations into your workflows and improve lead management without additional tools.
    `
    },
    {
      question: "Do I need technical skills to use Vilva Chat?",
      answer: `
      Not at all. Vilva Chat is designed for business users, with an easy-to-use dashboard that lets you automate responses, design campaign messages, and manage interactions — no coding needed.
    `
    },
    {
      question: "Is customer data safe with Vilva Chat?",
      answer: `
      Yes. Vilva Chat operates using the official WhatsApp Business API, which ensures security, authenticity, and compliance with WhatsApp’s standards, giving you peace of mind while engaging customers.
    `
    },
    {
      question: "Can it respond automatically even when my team is offline?",
      answer: `
      Yes. One of Vilva Chat’s biggest benefits is 24/7 automated responses — so customers get instant replies anytime, boosting satisfaction and business reach.
    `
    },
    {
      question: "How soon can I start using Vilva Chat?",
      answer: `
      After setup, you can begin automating chats and campaigns right away. Our team assists with onboarding so your business can start engaging customers faster.
    `
    },
    {
      question: "Why choose Vilva Chat over other WhatsApp business tools?",
      answer: `
      Vilva Chat combines:
      <ul>
        <li>Official verified WhatsApp API</li>
        <li>Intelligent automation and chatbot features</li>
        <li>Campaign and messaging tools</li>
        <li>Easy integration and onboarding</li>
      </ul>
    `
    }
  ];

  useAOS();

  return (
    <>
      <div className='min-h-screen'>


        <section className="bg-[#F0FFF0] relative min-h-screen">
          <div className="px-4 lg:px-8 xl:px-0 md:container py-[80px]">
            <div className="flex flex-col md:flex-row">

              {/* Content Section - Right on Desktop, Top on Mobile */}
              <div className="w-full md:w-1/2 mb-[24px] md:order-2 order-1">
                <p
                  data-aos-now className="inline-flex mb-[27px] px-[16px] py-[8px] justify-end items-end rounded-[26px] border-[0.8px] border-[#FAE4AC] bg-[#FEFFE6] text-[#C48C00] font-Schibsted_Grotesk text-[12px] md:text-[16px] font-normal"
                >
                  Vilva Chat - Made in Tamil Nadu
                </p>
                <h1 data-aos-now className="flex leading-[120%] items-center flex-wrap text-[36px] md:text-[32px] lg:text-[44px] xl:text-[56px] 2xl:text-[68px] mb-[24px] font-NeueMontreal font-normal bg-gradient-to-r from-[#00D527] to-[#00930F] bg-clip-text text-transparent">
                  Grow Sales 3X <SvgIcons.WhatsEaseBot className='w-[35px] md:w-[48px] xl:w-[60px] 2xl:w-[70px]' />
                  <span className="text-[36px] md:text-[32px] lg:text-[38px] xl:text-[50px] 2xl:text-[60px] font-NeueMontreal font-normal text-[#090D28] whitespace-normal xl:text-nowrap">
                    Faster Using Automated
                  </span>
                  <span className="text-[36px] md:text-[32px] lg:text-[38px] xl:text-[50px] 2xl:text-[60px] font-NeueMontreal font-normal text-[#00D527] whitespace-normal xl:text-nowrap">WhatsApp <span className='text-[#00930F] text-[36px] md:text-[32px] lg:text-[38px] xl:text-[50px] 2xl:text-[60px] font-NeueMontreal font-normal'>Message</span></span>
                </h1>
                <p
                  data-aos-now style={{ animationDelay: "80ms" }} className="text-[#2A3B2B] mb-[24px] font-Schibsted_Grotesk text-[16px] md:text-[20px] font-normal leading-[150%]"
                >
                  Unlock the power of direct, automated, and data-driven communication with{' '}
                  <span className="text-[#0EAC0E] font-Schibsted_Grotesk text-[16px] md:text-[20px] font-normal leading-[200%]">
                    Vilva Chat
                  </span>
                  . your all-in-one WhatsApp marketing tool, proudly built in{' '}
                  <span className="text-[#0EAC0E] font-Schibsted_Grotesk text-[16px] md:text-[20px] font-normal leading-[200%]">
                    Tamil Nadu
                  </span>
                  .
                </p>
                <div data-aos-now style={{ animationDelay: "160ms" }} className="flex items-center gap-[12px]">
                  <Link target='_blank'
                    className="flex justify-center items-center gap-[10px] rounded-[32px] border w-[160px] h-[52px] px-[6px] py-[10px] border-[#0EAC0E] bg-white text-[#0EAC0E] font-Schibsted_Grotesk text-[18px] font-normal"
                    href="/book-demo"
                  >
                    Book a Demo
                  </Link>
                  <Link target='_blank'
                    className="flex w-[160px] h-[52px] px-[6px] py-[10px] justify-center items-center gap-[10px] rounded-[32px] bg-[#0EAC0E] text-white font-Schibsted_Grotesk text-[18px] font-normal"
                    href="https://whatsappforstartups.vilvabusiness.com/"
                  >
                    Start Now
                  </Link>
                </div>
              </div>

              {/* Image Section - Left on Desktop, Bottom on Mobile */}
              <div className="w-full md:w-1/2 md:order-1 order-2">
                <div
                  className="animate-wave inline-flex h-[14px] md:h-[28px] px-[8px] md:px-[14.182px] py-[3px] md:py-[6.303px] justify-center items-center gap-[4.727px] flex-shrink-0 rounded-[23.636px] bg-[linear-gradient(180deg,_#FFF_50%,_#ADFFAD_137.86%)] shadow-[0px_1px_4px_0px_rgba(9,137,0,0.25)] text-[#006300] font-Schibsted_Grotesk text-[7px] md:text-[12.606px] not-italic font-medium leading-none"
                >
                  <SvgIcons.WhatseaseWhatsapp className='w-[9px] md:w-[15px]' />
                  Automated customer chats
                </div>
                <div className="relative">
                  {/* Mobile Image */}
                  <Image
                    src={getImageUrl("/vilvabusiness/website/products/vilvachat/vilvachat_mob_1.webp")}
                    alt="Vilva Chat WhatsApp Business app on mobile"
                    width={360}
                    height={300}
                    sizes="100vw"
                    priority
                    className="block sm:hidden"
                  />

                  {/* Laptop / Desktop Image */}
                  <Image
                    src={getImageUrl("/vilvabusiness/website/products/vilvachat/whatschatImage.webp")}
                    alt="Vilva Chat WhatsApp Business API dashboard"
                    width={671}
                    height={538}
                    priority
                    sizes="(max-width: 1024px) 100vw, 671px"
                    className="hidden sm:block"
                  />
                </div>
                <div
                  className="animate-wave2 inline-flex h-[14px] md:h-[28px] px-[8px] md:px-[14.182px] py-[3px] md:py-[6.303px] justify-center items-center gap-[4.727px] flex-shrink-0 rounded-[23.636px] bg-[linear-gradient(180deg,_#FFF_50%,_#ADFFAD_137.86%)] shadow-[0px_1px_4px_0px_rgba(9,137,0,0.25)] text-[#006300] font-Schibsted_Grotesk text-[7px] md:text-[12.606px] not-italic font-medium leading-none"
                >
                  <SvgIcons.WhatseaseWhatsapp className='w-[9px] md:w-[15px]' />
                  Whatsapp Marketing
                </div>
              </div>
            </div>
          </div>
        </section>

        <TrustedPartners className="relative py-[40px]" />

        <section className=' pt-[80px] overflow-hidden relative md:pt-[160px] bg-[radial-gradient(149.33%_80.3%_at_44.91%_-2.78%,_#00B049_0%,_#00431C_100%)]'>
          <section className="px-3 md:px-0 md:container relative">
            <p data-aos="fade-up" data-aos-duration="1000" className="text-[#FDFF81] text-center font-NeueMontreal text-[32px] md:text-[52px] font-normal leading-[120%] ">Automate & Accelerate Conversions.</p>
            <div className="max-w-7xl mx-auto py-10">
              <div className="grid grid-cols-2 lg:grid-cols-4">
                {WHATSEASE_STATS.map((stat, i) => (
                  <div
                    key={stat.label}
                    className={`px-4 md:px-12 py-6 border-[#40AB6C] ${
                      i === 0 ? "border-b lg:border-b-0 border-r"
                      : i === 1 ? "border-b lg:border-b-0 lg:border-r"
                      : i === 2 ? "border-r lg:border-r"
                      : ""
                    }`}
                  >
                    <p className="text-white text-center font-NeueMontreal text-4xl md:text-5xl">
                      <StatNumber
                        display={stat.value}
                        exact={stat.exact}
                        target={stat.target}
                        format={stat.format}
                      />
                    </p>
                    <p className="mt-1 text-[#CAE0D3] text-center font-Schibsted_Grotesk text-sm md:text-lg">
                      {stat.label}
                    </p>
                  </div>
                ))}
              </div>
              <UpdatedAt
                iso={WHATSEASE_UPDATED_AT}
                className="mt-4 text-center font-Schibsted_Grotesk text-[12px] font-normal text-[#CAE0D3] opacity-70"
              />
            </div>

            <div className='flex justify-center items-center  flex-col mx-auto relative'>
              <div className='block md:flex-col items-center justify-center gap-0  pt-[80px]'>
                <p className='text-center mb-[40px]'>
                  <span className="text-transparent text-center bg-gradient-to-r from-[#FDFF81] to-[#91FF13] bg-clip-text font-NeueMontreal text-[28px] md:text-[32px] font-normal">Whatsapp API x Vilva Speeds them up!</span></p>
                <div data-aos="fade-up" data-aos-duration="1000" className=' max-w-5xl mx-auto z-50 w-full md:w-[658px] lg:w-[1149.55px] h-auto'>
                  <Image
                    src={getImageUrl("/vilvabusiness/website/products/vilvachat/dashboard.webp")}
                    alt="Vilva Chat WhatsApp campaign and analytics dashboard"
                    width={1149}
                    height={647}
                    loading="lazy"
                    sizes="(max-width: 768px) 100vw, (max-width: 1024px) 658px, 1149px"
                    className='md:block hidden'
                  />

                  <Image
                    src={getImageUrl("/vilvabusiness/website/products/vilvachat/dashboard_mob_1.webp")}
                    alt="Vilva Chat dashboard on mobile"
                    width={640}
                    height={400}
                    loading="lazy"
                    sizes="calc(100vw - 32px)"
                    className="w-full h-auto rounded-lg block md:hidden"
                  />
                </div>
              </div>
            </div>
          </section>
          <div data-aos="fade-up" data-aos-duration="1000" className='hidden lg:block absolute left-24 -bottom-10'>
            <SvgIcons.WhtasEaseKite />
          </div>
        </section>

        <div>
          <TurnWhatsapp />
        </div>
        <section>
          <div className="flex flex-col justify-center py-[80px] md:py-[100px]">

            <div className="bg-white p-6 max-w-5xl w-full mx-auto">
              <p className="text-[#003114] text-center font-NeueMontreal text-[32px] md:text-[48px] font-normal mb-[60px] max-w-[990px] mx-auto lg:text-nowrap"
              >
                Launch WhatsApp Campaigns in 5 Easy Steps
              </p>
            </div>
            <StepsLayout />
          </div>

        </section>

        <section className='py-[80px] md:py-[80px]'>
          <h2 data-aos="fade-up" data-aos-duration="1000" className="text-[#003114] px-4 mb-4 text-center font-NeueMontreal text-[36px] md:text-[48px] font-normal font-NeueMontreal">The Complete Business Toolkit</h2>
          <p data-aos="fade-up" data-aos-duration="1000" className="text-[#2A3B2B] px-4 text-center mb-[48px] font-Schibsted_Grotesk text-[16px] md:text-[18px] font-normal font-Schibsted_Grotesk">
            Automate conversations, manage contacts, track results in real-time, and connect across platforms
          </p>
          <section>
            <div className="grid gap-[24px] px-4 md:px-0 md:container grid-cols-1 md:grid-cols-2 lg:grid-cols-3">
              <div data-aos="fade-up" data-aos-duration="1000" className="rounded-[16px] p-[24px] border border-[#DBFFCE] bg-[#F5FFF0]">
                <div className="flex justify-center">
                  <SvgIcons.BussniessToolGroup />
                </div>
                <p className="text-[#090D28] font-NeueMontreal text-[24px] font-normal mt-[48px] mb-[13px]">Contact & Group Management</p>
                <p className="text-[#2A3B2B] font-Schibsted_Grotesk text-[16px] font-normal">Import, export, and manage contacts with ease. Segment audiences using groups and custom fields to enable smarter, targeted WhatsApp marketing.</p>
              </div>
              <div data-aos="fade-up" data-aos-duration="1000" className="rounded-[16px] p-[24px] border border-[#DBFFCE] bg-[#F5FFF0]">
                <div className="flex justify-center">
                  <SvgIcons.BussniessToolCampaign />
                </div>
                <p className="text-[#090D28] font-NeueMontreal text-[24px] font-normal mt-[48px] mb-[13px]">Campaign Management</p>
                <p className="text-[#2A3B2B] font-Schibsted_Grotesk text-[16px] font-normal">Easily launch and track WhatsApp campaigns with a centralized dashboard. Schedule messages, monitor delivery and read rates in real time, and get complete visibility into campaign performance—all in one powerful platform.</p>
              </div>
              <div data-aos="fade-up" data-aos-duration="1000" className="rounded-[16px] p-[24px] border border-[#DBFFCE] bg-[#F5FFF0]">
                <div className="flex justify-center">
                  <SvgIcons.BussniessToolTemplate />
                </div>
                <p className="text-[#090D28] font-NeueMontreal text-[24px] font-normal mt-[48px] mb-[13px]">Template Management</p>
                <p className="text-[#2A3B2B] font-Schibsted_Grotesk text-[16px] font-normal">Manage your WhatsApp marketing message templates efficiently. Sync directly with Meta, create new templates, and organize them for different use cases—all from one place. Ensure quick, compliant communication through your approved WhatsApp API message templates.</p>
              </div>
              <div data-aos="fade-up" data-aos-duration="1000" className="rounded-[16px] p-[24px] border border-[#DBFFCE] bg-[#F5FFF0]">
                <div className="flex justify-center">
                  <SvgIcons.BussniessToolBotReplay />
                </div>
                <p className="text-[#090D28] font-NeueMontreal text-[24px] font-normal mt-[48px] mb-[13px]">Bot Replies & Flow Builder</p>
                <p className="text-[#2A3B2B] font-Schibsted_Grotesk text-[16px] font-normal">Automate conversations using our visual WhatsApp chatbot builder. Design smart replies with links, buttons, and list items to guide users through interactions. Set trigger conditions that launch specific bots based on user actions — essential for scalable WhatsApp automations.</p>
              </div>
              <div data-aos="fade-up" data-aos-duration="1000" className="rounded-[16px] p-[24px] border border-[#DBFFCE] bg-[#F5FFF0]">
                <div className="flex justify-center">
                  <SvgIcons.BussniessToolBotIntegration />
                </div>
                <p className="text-[#090D28] font-NeueMontreal text-[24px] font-normal mt-[48px] mb-[13px]">AI Bot Integration with FlowiseAI</p>
                <p className="text-[#2A3B2B] font-Schibsted_Grotesk text-[16px] font-normal">Leverage no-code WhatsApp AI chatbots to automate vendor and customer support. Built on FlowiseAI, these bots handle queries in real-time, improving engagement and reducing manual workload — a powerful tool for any WhatsApp marketing service.</p>
              </div>
              <div data-aos="fade-up" data-aos-duration="1000" className="rounded-[16px] p-[24px] border border-[#DBFFCE] bg-[#F5FFF0]">
                <div className="flex justify-center">
                  <SvgIcons.BussniessToolwhtasappInte />
                </div>
                <p className="text-[#090D28] font-NeueMontreal text-[24px] font-normal mt-[48px] mb-[13px]">Integrated WhatsApp Chat</p>
                <p className="text-[#2A3B2B] font-Schibsted_Grotesk text-[16px] font-normal">Deliver support through a native-like WhatsApp for Business chat interface. The familiar design ensures a seamless experience for your team and customers, improving real-time communication, response times, and customer satisfaction.</p>
              </div>
              <div data-aos="fade-up" data-aos-duration="1000" className="rounded-[16px] p-[24px] border border-[#DBFFCE] bg-[#F5FFF0]">
                <div className="flex justify-center">
                  <SvgIcons.BussniessToolQrgenrate />
                </div>
                <p className="text-[#090D28] font-NeueMontreal text-[24px] font-normal mt-[48px] mb-[13px]">QR Code Generator</p>
                <p className="text-[#2A3B2B] font-Schibsted_Grotesk text-[16px] font-normal">Instantly generate QR codes for your campaigns or business contact links. A great tool for simplifying onboarding, enhancing engagement, and promoting offline-to-online transitions with your WhatsApp marketing tool.</p>
              </div>
              <div className="rounded-[16px] p-[24px] border border-[#DBFFCE] bg-[#F5FFF0]">
                <div className="flex justify-center">
                  <SvgIcons.BussniessToolDashboard />
                </div>
                <p className="text-[#090D28] font-NeueMontreal text-[24px] font-normal mt-[48px] mb-[13px]">Advanced Analytics Dashboard</p>
                <p className="text-[#2A3B2B] font-Schibsted_Grotesk text-[16px] font-normal">Track your platform usage in real-time. Monitor total templates created, messages processed, queue stats, and team metrics. Enjoy complete visibility into every element of your WhatsApp marketing campaigns and WhatsApp business API integration.</p>
              </div>
              <div className="rounded-[16px] p-[24px] border border-[#DBFFCE] bg-[#F5FFF0]">
                <div className="flex justify-center">
                  <SvgIcons.BussniessToolInviteMessage />
                </div>
                <p className="text-[#090D28] font-NeueMontreal text-[24px] font-normal mt-[48px] mb-[13px]">Interactive Messages</p>
                <p className="text-[#2A3B2B] font-Schibsted_Grotesk text-[16px] font-normal">Make every message count - use interactive buttons, media, and replies to boost engagement and guide customers toward action.</p>
              </div>
            </div>
          </section>
        </section>

        <section className='py-[60px] md:py-[120px] bg-[#143C23]'>
          <p data-aos="fade-up" data-aos-duration="1000" className="text-white px-4 font-NeueMontreal text-center text-[28px] md:text-[40px] font-normal">Turn Every WhatsApp Message into a Business Opportunity</p>
          <div data-aos="fade-up" data-aos-duration="1000" className='flex items-center justify-center mt-[30px] gap-[12px]'>
            <Link className="flex justify-center items-center gap-[10px] rounded-[32px] border w-[160px] h-[52px] px-[6px] py-[10px] border-[#0EAC0E] bg-white text-[#0EAC0E] font-Schibsted_Grotesk text-[18px] font-normal" href='/book-demo'>Book a Demo</Link>
            <Link target='_blank' href="https://whatsappforstartups.vilvabusiness.com/" className="flex w-[160px] h-[52px] px-[6px] py-[10px] justify-center items-center gap-[10px] rounded-[32px] bg-[#0EAC0E] text-white font-Schibsted_Grotesk text-[18px] font-normal">Start Now</Link>
          </div>
        </section>

        <section className="bg-[linear-gradient(90deg,_#FFC42E_0%,_#FFEF3D_50%,_#FFC42E_100%)] flex p-[10px] justify-center items-center gap-[10px] overflow-hidden">
          <div className="inline-block sm:flex sm:flex-wrap animate-[scroll_15s_linear_infinite] lg:animate-none">
            <p className="text-[#090D28] font-Schibsted_Grotesk text-[12px] font-normal whitespace-nowrap lg:whitespace-normal">
              WhatsApp® is a registered trademark of its owners. Our product uses the official WhatsApp Cloud API to provide a reliable messaging experience, independently developed and aligned with WhatsApp’s standards.
            </p>
          </div>
        </section>

        <section className='py-[80px] md:py-[100px]'>
          <h2 data-aos="fade-up" data-aos-duration="1000" className="text-[#003114] text-center font-NeueMontreal text-[32px] md:text-[48px] font-normal mb-[57px]">Why Trust Vilva?</h2>
          <div className="flex flex-wrap px-3 md:px-0 md:container gap-[24px] justify-center items-center">
            <div data-aos="fade-up" data-aos-duration="1000" className="inline-flex w-full md:w-fit gap-2 h-[100px] px-[16px] md:px-[25px] justify-center items-center flex-shrink-0 rounded-[16px] border border-[#FFF5CE] bg-[#FFFFF0]">
              <SvgIcons.TrustTick />
              <p className="text-[#4F4F22] font-NeueMontreal text-[16px] md:text-[20px] font-normal">Smarter Campaigns, Higher Conversions</p>
            </div>
            <div data-aos="fade-up" data-aos-duration="1000" className="inline-flex w-full md:w-fit gap-2 h-[100px] px-[16px] md:px-[25px] justify-center items-center flex-shrink-0 rounded-[16px] border border-[#FFF5CE] bg-[#FFFFF0]">
              <SvgIcons.TrustTick />
              <p className="text-[#4F4F22] font-NeueMontreal text-[16px] md:text-[20px] font-normal">24/7 Intelligent Support</p>
            </div>
            <div data-aos="fade-up" data-aos-duration="1000" className="inline-flex w-full md:w-fit gap-2 h-[100px] px-[16px] md:px-[25px] justify-center items-center flex-shrink-0 rounded-[16px] border border-[#FFF5CE] bg-[#FFFFF0]">
              <SvgIcons.TrustTick />
              <p className="text-[rgb(79,79,34)] font-NeueMontreal text-[16px] md:text-[20px] font-normal">Simple, Scalable, Server-Free</p>
            </div>
            <div data-aos="fade-up" data-aos-duration="1000" className="inline-flex w-full md:w-fit gap-2 h-[100px] px-[16px] md:px-[25px] justify-center items-center flex-shrink-0 rounded-[16px] border border-[#FFF5CE] bg-[#FFFFF0]">
              <SvgIcons.TrustTick />
              <p className="text-[#4F4F22] font-NeueMontreal text-[16px] md:text-[20px] font-normal">Centralized Control, Total Transparency</p>
            </div>
            <div data-aos="fade-up" data-aos-duration="1000" className="inline-flex w-full md:w-fit gap-2 h-[100px] px-[16px] md:px-[25px] justify-center items-center flex-shrink-0 rounded-[16px] border border-[#FFF5CE] bg-[#FFFFF0]">
              <SvgIcons.TrustTick />
              <p className="text-[#4F4F22] font-NeueMontreal text-[16px] md:text-[20px] font-normal">Connect Instantly. Communicate Authentically.</p>
            </div>
          </div>
        </section>

        <section className='bg-[#F5FFF5] py-[80px] md:py-[160px]'>
          <div className="px-4 md:px-0 md:container">
            <h2 className="text-[#003114] text-center font-NeueMontreal text-[32px] md:text-[48px] font-normal mb-[60px]">Plans that match your needs</h2>
            <div className="md:container gap-[40px] flex md:flex-row flex-col items-center justify-center">
              {/* <div className="rounded-[12px] hover:shadow-2xl p-[16px] border border-[#C2F7D5] bg-gradient-to-b from-[#F0FFF6] via-[#F0FFF6] to-[#BBFFD5]">
              <p className="text-[#F0FFF6] text-center font-Schibsted_Grotesk text-[18px] font-normal inline-flex px-[12px] mb-[20px] pt-[1px] pb-[4px] leading-none justify-center items-center gap-[10px] rounded-[14px] bg-[#102D1B]">Free Plan</p>
              <p className="text-[#08C908] font-NeueMontreal text-[32px] font-normal mb-[6px]">Free</p>
              <p className="text-[#090D28] font-Schibsted_Grotesk text-[12px] font-normal mb-[20px]">For Eligible Startups</p>
              <div className="bg-[#C2F7D5] w-full h-[1px] mb-[20px]"></div>
              <ul className='ps-3'>
                <li className="text-[#090D28] font-Schibsted_Grotesk text-[16px] font-normal flex items-center gap-2 mb-[16px]"><SvgIcons.TrustTick />AI Chat Bot</li>
                <li className="text-[#090D28] font-Schibsted_Grotesk text-[16px] font-normal flex items-center gap-2 mb-[16px]"><SvgIcons.TrustTick />Campaign Management</li>
                <li className="text-[#090D28] font-Schibsted_Grotesk text-[16px] font-normal flex items-center gap-2 mb-[16px]"><SvgIcons.TrustTick />Integrated WhatsApp Chat</li>
                <li className="text-[#090D28] font-Schibsted_Grotesk text-[16px] font-normal flex items-center gap-2 mb-[16px]"><SvgIcons.TrustTick />Bot Flow Builder</li>
                <li className="text-[#090D28] font-Schibsted_Grotesk text-[16px] font-normal flex items-center gap-2 mb-[16px]"><SvgIcons.TrustTick />QR Code Generation</li>
                <li className="text-[#090D28] font-Schibsted_Grotesk text-[16px] font-normal flex items-center gap-2 mb-[47px]"><SvgIcons.TrustTick />API & Webhook</li>
              </ul>
              <div className='flex items-center justify-center flex-col gap-[12px]'>
                <p className="text-[#102D1B] text-center font-Schibsted_Grotesk text-[12px] font-normal">GST+Cloud Messaging Charges Apply</p>
                <button type='button' className="text-[#F8FF30] font-LatinkaSemiBold text-[16px] font-normal flex w-full p-[10px] justify-center items-center gap-[10px] flex-shrink-0 rounded-[20px] bg-[#102D1B]">Join the Plan Now</button>
                <p className="text-[#102D1B] text-center font-Schibsted_Grotesk text-[12px] font-normal">Assisted Setup Charges(Optional)</p>
              </div>
            </div> */}
              <div className="rounded-[12px] w-full md:w-[350px] hover:shadow-2xl relative bg-[#102D1B] shadow-[0px_2px_20px_0px_rgba(16,45,27,0.4)] p-[16px]">
                <div className="text-[#102D1B] font-Schibsted_Grotesk text-[15px] font-normal inline-flex px-[10px] py-[6px] justify-center items-center gap-[10px] rounded-tr-[11px] bg-[linear-gradient(90deg,_#FFC42E_0%,_#FFEF3D_50%,_#FFC42E_100%)] absolute top-0 right-0">
                  Popular
                </div>
                <p className="text-[#00C149] text-center font-Schibsted_Grotesk text-[18px] font-normal w-fit flex items-center justify-center gap-[10px] mb-[20px] leading-none px-[12px] py-[4px] pt-[2px] pb-[4px] rounded-[14px] bg-[#1F5734]">Business Plan</p>
                <p className="text-[#08C908] font-NeueMontreal text-[32px] font-normal mb-[6px]">Rs.9999</p>
                <p className="text-[#AFD58E] font-Schibsted_Grotesk text-[12px] font-normal mb-[20px]">Per Month - Billing Anually</p>
                <div className="bg-[#2E4B39] w-full h-[1px] mb-[20px]"></div>
                <ul className='ps-3'>
                  <li className="text-white font-Schibsted_Grotesk text-[16px] font-normal flex items-center gap-2 mb-[16px]"><SvgIcons.TrustTick />AI Chat Bot</li>
                  <li className="text-white font-Schibsted_Grotesk text-[16px] font-normal flex items-center gap-2 mb-[16px]"><SvgIcons.TrustTick />Campaign Management</li>
                  <li className="text-white font-Schibsted_Grotesk text-[16px] font-normal flex items-center gap-2 mb-[16px]"><SvgIcons.TrustTick />Integrated WhatsApp Chat</li>
                  <li className="text-white font-Schibsted_Grotesk text-[16px] font-normal flex items-center gap-2 mb-[16px]"><SvgIcons.TrustTick />Bot Flow Builder</li>
                  <li className="text-white font-Schibsted_Grotesk text-[16px] font-normal flex items-center gap-2 mb-[16px]"><SvgIcons.TrustTick />QR Code Generation</li>
                  <li className="text-white font-Schibsted_Grotesk text-[16px] font-normal flex items-center gap-2 mb-[47px]"><SvgIcons.TrustTick />API & Webhook</li>
                </ul>
                <div className='flex items-center justify-center flex-col gap-[12px]'>
                  <p className="text-[#fff] text-center font-Schibsted_Grotesk text-[12px] font-normal">GST+Cloud Messaging Charges Apply</p>
                  <Link target='_blank' href="https://whatsappforstartups.vilvabusiness.com/" className="text-[#102D1B] font-LatinkaSemiBold text-[16px] font-normal flex w-full p-[10px] justify-center items-center gap-[10px] flex-shrink-0 rounded-[20px] bg-[#F8FF30]">Join the Plan Now</Link>
                  <p className="text-[#fff] text-center font-Schibsted_Grotesk text-[12px] font-normal">Assisted Setup Charges(Optional)</p>
                </div>
              </div>
              <div className="rounded-[12px] w-full md:w-[350px] hover:shadow-2xl p-[16px] border border-[#C2F7D5] bg-gradient-to-b from-[#F0FFF6] via-[#F0FFF6] to-[#BBFFD5]">
                <p className="text-[#F0FFF6] text-center font-Schibsted_Grotesk text-[18px] font-normal inline-flex px-[12px] py-[4px] mb-[20px] pt-[1px] pb-[4px] leading-none justify-center items-center gap-[10px] rounded-[14px] bg-[#102D1B]">Enterprise Plan</p>
                <p className="text-[#08C908] font-NeueMontreal text-[32px] font-normal mb-[6px]">Custom Price</p>
                <p className="text-[#090D28] font-Schibsted_Grotesk text-[12px] font-normal mb-[20px]">Per Month - Billing Anually</p>
                <div className="bg-[#C2F7D5] w-full h-[1px] mb-[20px]"></div>
                <ul className='ps-3'>
                  <li className="text-[#090D28] font-Schibsted_Grotesk text-[16px] font-normal flex items-center gap-2 mb-[16px]"><SvgIcons.TrustTick />AI Chat Bot</li>
                  <li className="text-[#090D28] font-Schibsted_Grotesk text-[16px] font-normal flex items-center gap-2 mb-[16px]"><SvgIcons.TrustTick />Campaign Management</li>
                  <li className="text-[#090D28] font-Schibsted_Grotesk text-[16px] font-normal flex items-center gap-2 mb-[16px]"><SvgIcons.TrustTick />Integrated WhatsApp Chat</li>
                  <li className="text-[#090D28] font-Schibsted_Grotesk text-[16px] font-normal flex items-center gap-2 mb-[16px]"><SvgIcons.TrustTick />Bot Flow Builder</li>
                  <li className="text-[#090D28] font-Schibsted_Grotesk text-[16px] font-normal flex items-center gap-2 mb-[16px]"><SvgIcons.TrustTick />QR Code Generation</li>
                  <li className="text-[#090D28] font-Schibsted_Grotesk text-[16px] font-normal flex items-center gap-2 mb-[47px]"><SvgIcons.TrustTick />API & Webhook</li>
                </ul>
                <div className='flex items-center justify-center flex-col gap-[12px]'>
                  <p className="text-[#102D1B] text-center font-Schibsted_Grotesk text-[12px] font-normal">GST+Cloud Messaging Charges Apply</p>
                  <Link href='/contact-us' className="text-[#F8FF30] font-LatinkaSemiBold text-[16px] font-normal flex w-full p-[10px] justify-center items-center gap-[10px] flex-shrink-0 rounded-[20px] bg-[#102D1B]">Contact Us</Link>
                  <p className="text-[#102D1B] text-center font-Schibsted_Grotesk text-[12px] font-normal">Assisted Setup Charges(Optional)</p>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className='px-4 md:px-0 md:container pb-[80px] md:pb-[160px]'>
          {/* <h2 className="text-[#090D28] text-center text-[32px] w-full mx-auto whitespace-normal md:whitespace-nowrap md:text-[40px] font-extrabold leading-[120%] font-NeueMontreal">
            Frequently Asked Questions?
          </h2> */}
          <FaqSection faqs={faqs} />
        </section>
      </div>
    </>
  )
}



export default WhatseaseView